module.exports = function getResource(label) {
    const resources = {
        title: 'Fermer le compte',
        checkboxText: 'Je comprends que je perds les avantages du programme Beauty Insider ci-dessus',
        cancelButton: 'Annuler',
        listTitleText: 'En vous désabonnant du programme Sephora Beauty Insider, vous :',
        item1: '1. Vous pouvez toujours vous connecter à Sephora, mais nous supprimerons les points liés à votre compte',
        item2: '2. Vous ne pourrez plus vous abonner aux textos?',
        item3: '3. Ne recevrez plus le cadeau d’anniversaire annuel de Sephora.',
        item4: '4. Ne pourrez plus participer en tant que membres de la collectivité Sephora',
        item5: '5. Vous ne serez plus en mesure de publier une évaluation ou de répondre à des questions.',
        item6: '6. Any account linked to your Sephora account (Kohls, Doordash, Instacart, Facebook, Shipt) will be unlinked.',
        item7: '7. If you have Auto-Replenish items, any shipment that has not shipped will be canceled and the Auto-Replenish enrollment will end.',
        item8: '8. If you have subscribed to the Same-Day Unlimited service, your subscription will end without any refund and the annual renewal will be canceled.',
        postListText: 'Closing your Sephora account will not affect open orders, returns, and Paid Service appointments. In addition, if you have the Sephora Credit Card, you will be able to continue to use the credit card and check balances on the bank’s website, and you will continue to receive bank rewards for qualifying purchases.'
    };
    return resources[label];
};

